import React, { useState } from 'react';
import { supabase } from './supabase';

export default function Login({ onLogin, onForgotPassword }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [restaurantName, setRestaurantName] = useState('');
  const [managerName, setManagerName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [signupSuccess, setSignupSuccess] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      const { data: { user } } = await supabase.auth.getUser();
const isManager = user?.user_metadata?.manager_name || user?.email === 'austinmr88@gmail.com';
onLogin(isManager ? 'manager' : 'employee', user);
    }
  }

  async function handleSignup(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          restaurant_name: restaurantName,
          manager_name: managerName,
        }
      }
    });
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setSignupSuccess(true);
      setLoading(false);
    }
  }

  if (signupSuccess) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl border border-gray-200 p-8 w-full max-w-sm text-center">
        <div className="text-4xl mb-4">🎉</div>
        <div className="text-lg font-medium text-gray-900 mb-2">You're on the list!</div>
        <div className="text-sm text-gray-400 mb-6">Check your email to confirm your account, then come back and sign in.</div>
        <button onClick={() => { setMode('login'); setSignupSuccess(false); setEmail(''); setPassword(''); }}
          className="w-full bg-blue-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-blue-700">
          Back to sign in
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl border border-gray-200 p-8 w-full max-w-sm">

        <div className="text-center mb-8">
          <div className="text-2xl font-medium text-gray-900 mb-1">Posted</div>
          <div className="text-sm text-gray-400">Restaurant scheduling, simplified.</div>
          <div className="text-xs text-gray-300 mt-1">86'd the whiteboard.</div>
        </div>

        {/* Mode toggle */}
        <div className="flex bg-gray-100 rounded-lg p-1 mb-6">
          <button onClick={() => { setMode('login'); setError(''); }}
            className={`flex-1 py-1.5 text-xs font-medium rounded-md ${mode === 'login' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-400'}`}>
            Sign in
          </button>
          <button onClick={() => { setMode('signup'); setError(''); }}
            className={`flex-1 py-1.5 text-xs font-medium rounded-md ${mode === 'signup' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-400'}`}>
            Create account
          </button>
        </div>

        {mode === 'login' ? (
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label className="text-xs font-medium text-gray-500 block mb-1.5">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@restaurant.com"
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-blue-400 bg-gray-50"
                required />
            </div>
            <div className="mb-6">
              <label className="text-xs font-medium text-gray-500 block mb-1.5">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-blue-400 bg-gray-50"
                required />
            </div>
            {error && <div className="mb-4 text-xs text-red-500 bg-red-50 px-3 py-2 rounded-lg">{error}</div>}
            <button type="submit" disabled={loading}
              className="w-full bg-blue-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
            {onForgotPassword && (
              <div className="mt-3 text-left">
                <button
                  type="button"
                  onClick={onForgotPassword}
                  className="text-xs text-gray-400 hover:text-gray-600 hover:underline"
                  style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit' }}
                >
                  Forgot password?
                </button>
              </div>
            )}
          </form>
        ) : (
          <form onSubmit={handleSignup}>
            <div className="mb-4">
              <label className="text-xs font-medium text-gray-500 block mb-1.5">Restaurant name</label>
              <input type="text" value={restaurantName} onChange={e => setRestaurantName(e.target.value)}
                placeholder="The Rustic Table"
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-blue-400 bg-gray-50"
                required />
            </div>
            <div className="mb-4">
              <label className="text-xs font-medium text-gray-500 block mb-1.5">Your name</label>
              <input type="text" value={managerName} onChange={e => setManagerName(e.target.value)}
                placeholder="Austin Murray"
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-blue-400 bg-gray-50"
                required />
            </div>
            <div className="mb-4">
              <label className="text-xs font-medium text-gray-500 block mb-1.5">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@restaurant.com"
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-blue-400 bg-gray-50"
                required />
            </div>
            <div className="mb-6">
              <label className="text-xs font-medium text-gray-500 block mb-1.5">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="min. 6 characters"
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-blue-400 bg-gray-50"
                required />
            </div>
            {error && <div className="mb-4 text-xs text-red-500 bg-red-50 px-3 py-2 rounded-lg">{error}</div>}
            <button type="submit" disabled={loading}
              className="w-full bg-blue-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
              {loading ? 'Creating account...' : 'Start free trial'}
            </button>
            <div className="mt-3 text-center text-xs text-gray-400">30 days free · No credit card required</div>
          </form>
        )}

      </div>
    </div>
  );
}